import { i18n } from "@lingui/core";
import { I18nProvider } from "@lingui/react";
import type { ReactNode } from "react";
import "./provider";

/**
 * The Lingui provider, alone in its own file.
 *
 * `provider.ts` beside it loads the catalogs and holds `useT`; splitting the
 * component out is what keeps Fast Refresh working — a module that exports both a
 * component and a hook is remounted on every edit to either.
 */
export function AdminI18nProvider({ children }: { children: ReactNode }) {
  return <I18nProvider i18n={i18n}>{children}</I18nProvider>;
}
